import { render, staticRenderFns } from "./WrsSpacingItem.vue?vue&type=template&id=5a7e603c&v-resize=onResize&"
import script from "./WrsSpacingItem.vue?vue&type=script&lang=js&"
export * from "./WrsSpacingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports